import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import Seo from "@/components/Seo";
import Breadcrumbs from "@/components/layout/Breadcrumbs";
import CtaBand from "@/components/sections/CtaBand";
import { usePackages } from "@/hooks/usePublicData";

export default function TourPackages() {
  const { data: packages = [] } = usePackages();
  return (
    <>
      <Seo title="Rajasthan Tour Packages by Taxi | Chouhan Taxi Service"
        description="Explore curated Rajasthan tour packages by private taxi — Jodhpur, Jaisalmer, Jaipur, Udaipur, family, couple and heritage tours with flexible itineraries."
        path="/tour-packages" />
      <Breadcrumbs items={[{ label: "Tour Packages" }]} />
      <section className="pt-8">
        <div className="container-x max-w-3xl">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-extrabold text-navy-heading leading-tight">Rajasthan Tour Packages</h1>
          <p className="mt-4 text-slate-600 leading-relaxed">Discover the royal state of Rajasthan with our private taxi tour packages. From a day of Jodhpur sightseeing to a full heritage circuit across the state, every package includes a comfortable vehicle and an experienced driver.</p>
        </div>
      </section>
      <section className="section-pad pt-10">
        <div className="container-x">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {packages.map((p) => (
              <Link key={p.slug} to={`/tour-packages/${p.slug}`} data-testid={`package-card-${p.slug}`}
                className="group bg-white rounded-2xl overflow-hidden border border-slate-100 shadow-sm card-hover">
                <div className="relative h-52 overflow-hidden">
                  <img src={p.image} alt={p.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  <div className="absolute top-3 left-3 bg-navy/90 text-white text-xs font-semibold px-3 py-1 rounded-full flex items-center gap-1"><Clock className="w-3 h-3" /> {p.duration}</div>
                </div>
                <div className="p-6">
                  <h2 className="font-heading font-semibold text-navy-heading text-lg">{p.title}</h2>
                  <p className="mt-2 text-sm text-slate-600 leading-relaxed line-clamp-2">{p.short}</p>
                  <div className="mt-4 flex items-center justify-end">
                    <span className="text-sm text-brand font-semibold inline-flex items-center gap-1 group-hover:gap-2 transition-all">View <ArrowRight className="w-3.5 h-3.5" /></span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
      <CtaBand title="Plan Your Rajasthan Tour" subtitle="Tell us your dates and interests and we'll craft the perfect private taxi tour for you." />
    </>
  );
}
